const _excluded = ["children", "className", "background", "boxRef", "divider", "flex", "flexBasis", "flexGrow", "flexShrink", "hideIfEmpty", "margin", "padding", "style"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'clsx';
import getDividerClassNames from "./getDividerClassNames";
import getFlexClassNames from "./getFlexClassNames";
import getMarginClassNames from "./getMarginClassNames";
import getPaddingClassNames from "./getPaddingClassNames";
import { getAlignItemsForOrigin } from "../Align/AlignBox";
import { useAlignContext } from "../Align/useAlignContext";

const Box = props => {
  const {
    children,
    className,
    background,
    boxRef,
    divider,
    flex,
    flexBasis,
    flexGrow,
    flexShrink,
    hideIfEmpty,
    margin,
    padding,
    style
  } = props,
        remaining = _objectWithoutProperties(props, _excluded);

  const marginMap = typeof margin === 'number' ? {
    all: margin
  } : margin;
  const paddingMap = typeof padding === 'number' ? {
    all: padding
  } : padding;
  let classes = classNames(className, 'Box-root', hideIfEmpty ? 'Box-hideIfEmpty' : null, background ? `Box-background--${background}` : null, divider ? getDividerClassNames(divider) : null, marginMap ? getMarginClassNames(marginMap) : null, paddingMap ? getPaddingClassNames(paddingMap) : null);
  const {
    alignContext,
    isAligned
  } = useAlignContext();

  const styleValue = _objectSpread({}, style);

  if (flexBasis != null) {
    styleValue.flexBasis = `${flexBasis}`;
  }

  if (flexGrow != null) {
    styleValue.flexGrow = `${flexGrow}`;
  }

  if (flexShrink != null) {
    styleValue.flexShrink = `${flexShrink}`;
  }

  if (!flex) {
    return /*#__PURE__*/React.createElement("div", _extends({}, remaining, {
      ref: boxRef,
      className: classes,
      style: styleValue
    }), children);
  }

  let alignFlex = flex; // Set the default value for align-items for aligned boxes with
  // flex-direction: row.

  if (isAligned) {
    // 'row' is the default value for flex-direction.
    const defaultAlignItems = getAlignItemsForOrigin(alignContext.origin);

    if (typeof flex === 'boolean') {
      alignFlex = {
        alignItems: defaultAlignItems
      };
    } else if (flex.direction !== 'column') {
      alignFlex = _objectSpread(_objectSpread({}, flex), {}, {
        alignItems: flex.alignItems ? flex.alignItems : defaultAlignItems
      });
    }
  }

  classes = classNames(classes, alignFlex ? getFlexClassNames(alignFlex) : null);
  return /*#__PURE__*/React.createElement("div", _extends({}, remaining, {
    ref: boxRef,
    className: classes,
    style: styleValue
  }), children);
};

export default Box;